import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import Navbar from '../components/Navbar';
import Layout from './Layout';
import Hero from '../components/Hero';
import Testimonial from '../components/Testimonial';
import Footer from '../components/Footer';
import Loading from '../components/Loading';
import toHref, { getSite } from '../tools/fetcher';
import Benefit from "../components/Benefit";
import Service from "../components/Service";
import About from "../components/About";

export default function Homepage() {
    const { isPending, isError, data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    useEffect(() => {
        let x = 1;
        const interval = setInterval(() => {
            const params = new URLSearchParams(window.location.search);
            const section = params.get('section');
            const element = document.getElementById(section);
            if (section) {
                console.log('CLEAR');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                    clearInterval(interval);
                }
            }
            x += 1;
            if (x > 50) {
                // 10 seconds
                clearInterval(interval);
            }
        }, 200);
        return () => clearInterval(interval);
    }, []); // Empty dependency array ensures this runs only once on mount

    if (isPending) {
        return <Loading />;
    }
    if (isError) {
        return <Loading>Error loading data</Loading>;
    }

    const pathImg = (imgName) =>
        toHref(
            `/wp-content/plugins/react-plugin/react-app/build/assets/${imgName}.png`,
        );

    return (
        <Layout className="min-w-[360px] font-dm-sans">
            <div className="bg-hero">
                <img
                    src={pathImg('bg-hero')}
                    alt={'bg-size'}
                    className="absolute h-[456px] z-0 sm:h-[764px] sm:w-1/2"
                />
                <div className="px-4 text-white z-0 sm:px-6 sm:pt-6 lg:px-8 xl:px-[140px]">
                    <Navbar data={data} className={'max-w-[1160px] mx-auto'} />
                </div>
                <div
                    id="hero"
                    className="h-[392px] px-4 pt-[60px] z-10 sm:h-[692px] sm:px-6 sm:pt-[134px] lg:px-8 xl:px-[140px]"
                >
                    <Hero className={' max-w-[1160px] mx-auto'} />
                </div>
            </div>
            <div
                id="benefit"
                className="px-6 py-8 sm:py-[120px] lg:px-8 xl:px-[140px]"
            >
                <Benefit
                    data={data}
                    className={'max-w-[1160px] mx-auto'}
                />
            </div>
            <div
                id="service"
                className="bg-primary-white-101 px-6 py-8 sm:py-[120px] lg:px-8 xl:px-[140px]"
            >
                <Service
                    data={data}
                    className={'max-w-[1160px] mx-auto'}
                />
            </div>
            <div
                id="about"
                className="px-6 py-8 sm:py-[120px] lg:px-8 xl:px-[140px]"
            >
                <About
                    data={data}
                    className={'max-w-[1160px] mx-auto'}
                />
            </div>
            <div
                id="testimonial"
                className="bg-primary-white-101 px-6 py-8 sm:py-[120px] lg:px-8 xl:px-[140px]"
            >
                <Testimonial
                    className={'max-w-[1160px] mx-auto'}
                    classNameSlider={'sm:px-6 lg:px-8 xl:px-[140px]'}
                    innerWidth={'mx-auto max-w-[1160px]'}
                />
            </div>
            <div
                id="footer"
                className="bg-primary-black-100 px-6 py-8 sm:py-[80px] lg:px-8 xl:px-[140px]"
            >
                <Footer data={data} className={'max-w-[1160px] mx-auto'} />
            </div>
        </Layout>
    );
}
